import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ICustoRecursoPlanejamentoModel } from 'src/app/models/custo-recurso-planejamento.model';
import { toFormatValue, toRemoveCharacters } from 'src/app/shared/util/toFormatValue';
import { CustoRecursoPlanejamentoService } from 'src/app/services/custo-recurso-planejamento.service';
import { BaseFormComponent } from '../../base-form/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import Swal from 'sweetalert2';
import { CustosRecursosOutrosFormModalComponent } from '../custos-recursos-outros-form-modal/custos-recursos-outros-form-modal.component';

@Component({
  selector: 'app-custos-recursos-outros-list',
  templateUrl: './custos-recursos-outros-list.component.html',
  styleUrls: ['./custos-recursos-outros-list.component.scss']
})

export class CustosRecursosOutrosListComponent extends BaseFormComponent implements OnInit {
  @Input() secaoId = 1;
  @Input() visualizar = false;
  @Output() subtotalChange = new EventEmitter<number>();

  public modelCustoRecursoPlanejamento: ICustoRecursoPlanejamentoModel = {} as ICustoRecursoPlanejamentoModel;
  public custoRecursoPlanejamentoDataSource = new MatTableDataSource<ICustoRecursoPlanejamentoModel>([]);
  public tipoTrabalho: string;
  public custoRecursoPlanejamentoSemDados = true;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private custoRecursoPlanejamentoService: CustoRecursoPlanejamentoService,
    public matDialog: MatDialog,
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.router.url.includes("planejamento")) {
      this.tipoTrabalho = 'planejamento';
    }
    if (this.router.url.includes("osa")) {
      this.tipoTrabalho = 'osa';
    }
  }

  ngOnInit(): void {
    this.carregarCustos();
  }

  ngOnChanges(): void {
    const total = this.calcularSubtotal();
    this.subtotalChange.emit(total);
  }

  public async carregarCustos() {
    try {
      this.custoRecursoPlanejamentoService.obterPorId(this.id, this.tipoTrabalho, this.secaoId).then((res) => {
        if (res.sucesso) {
          this.custoRecursoPlanejamentoDataSource = new MatTableDataSource<ICustoRecursoPlanejamentoModel>
            (
              res.dados
            );
          this.custoRecursoPlanejamentoDataSource._updateChangeSubscription();
          this.modelCustoRecursoPlanejamento = {} as ICustoRecursoPlanejamentoModel;
          this.custoRecursoPlanejamentoSemDados = res.dados.length != 0 ? false : true;
        } else {
          this.submit = false;
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'error',
            text: res.mensagem.descricao,
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          this.router.navigate(['/planejamento']);
          return;
        }
      });
    } catch (err) {
      this.submit = false;
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
      this.router.navigate(['/planejamento']);
    }
  }

  public async incluir() {
    try {
      debugger;
      const dados = {
        nome: null,
        planejamentoId: this.id,
        osaId: this.id,
        valorUnitario: null,
        quantidade: null,
        secaoId: this.secaoId
      } as ICustoRecursoPlanejamentoModel

      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = dados;
      const modal = this.matDialog.open(
        CustosRecursosOutrosFormModalComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe((data) => {
        this.carregarCustos();
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem?.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public async editar(model: ICustoRecursoPlanejamentoModel) {
    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-component';
      dialogConfig.width = '650px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = model;
      const modal = this.matDialog.open(
        CustosRecursosOutrosFormModalComponent,
        dialogConfig
      );
      modal.afterClosed().subscribe((data) => {
        this.carregarCustos();
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  excluir(id: number): void {
    Swal.fire({
      title: 'Confirma a exclusão?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        this.custoRecursoPlanejamentoService.excluir(id, this.tipoTrabalho).subscribe(res => {
          if (res.sucesso) {
            this.carregarCustos();
          }
        });
      }
    });
  }

  formatarInput(value) {
    return toFormatValue(value);
  }

  calcularSubtotal(): number {
    const total = this.custoRecursoPlanejamentoDataSource.data
      ?.reduce((total, item) => total + (item.quantidade * item.valorUnitario || 0), 0) || 0;

    this.subtotalChange.emit(total);

    return total;
  }
}
